/** 
 * Counter Checkout - Handles sending cart to Comerzzia for in-store payment
 * Only active in vertical display mode
 */

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    // Replace this URL with the actual Comerzzia endpoint when available
    //ENDPOINT: 'https://api.comerzzia.example/checkout',  
    //ENDPOINT: 'http://api-tramas-pre.tramasmas.com/shopifyintegra/api/shopify/cart?tienda=tramasmas.myshopify.com',
    ENDPOINT: 'https://tramas.tramasmas.com/shopifyintegra/api/shopify/cart?tienda=tramasmas.myshopify.com',
    DISPLAY_MODE: 'vertical'
  };

  // Check if we're in vertical display mode
  function isVerticalMode() {
    const urlParams = new URLSearchParams(window.location.search);
    const urlDisplay = urlParams.get('display');
    const localStorageDisplay = localStorage.getItem('display-mode');
    
    const isVertical = urlDisplay === CONFIG.DISPLAY_MODE || localStorageDisplay === CONFIG.DISPLAY_MODE;
    console.log('Checking vertical mode:', {urlDisplay, localStorageDisplay, isVertical});
    
    return isVertical;
  }

  

  /**
   * Get current cart data from Shopify
   */
  async function getCartData() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Failed to fetch cart');
      return await response.json();
    } catch (error) {
      console.error('Error fetching cart:', error);
      throw error;
    }
  } 

  

  // Prevenir cierre del modal por click fuera o escape
  function preventModalClose(e) {
    const counterCheckoutModal = document.getElementById('counter-checkout-modal');
    if (counterCheckoutModal && counterCheckoutModal.dataset.locked === 'true') {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  

  /**
   * Hide counter checkout modal
   */
  function hideCounterCheckoutModal() {
    const cartMainContent = document.getElementById('cart-main-content');
    const counterCheckoutModal = document.getElementById('counter-checkout-modal');
    const counterCheckoutForm = document.getElementById('counter-checkout-form');
    if (cartMainContent && counterCheckoutModal) {
      counterCheckoutModal.classList.add('hidden');
      cartMainContent.style.display = 'flex';
      
      // Reset form and restore visual state of destination selector
      if (counterCheckoutForm) {
        counterCheckoutForm.reset();
        updateDestinationUI();
      }
      hideKeyboard();
      showStatus('');
    }
  }

  

  /**
   * Show status message
   */
  function showStatus(message, isError = false) {
    const statusElement = document.getElementById('counter-checkout-status');
    if (!statusElement) return;
    
    statusElement.textContent = message;
    statusElement.className = `counter-checkout__status text-sm ${isError ? 'text-red-600' : 'text-green-600'}`;
  }

  function cartHasRestrictedLowStockItems() {
    return Array.from(document.querySelectorAll('[data-public-stock]')).some(function(item) {
      const stock = Number(item.getAttribute('data-public-stock'));
      return Number.isFinite(stock) && stock < 10;
    });
  }

  /**
   * Update visual state of destination option cards.
   * Defined at IIFE scope so it is accessible from both initDestinationSelector
   * and the document-level delegation handler.
   */
  function updateDestinationUI() {
    const selected = document.querySelector('input[name="destination_type"]:checked')?.value;
    document.querySelectorAll('[data-destination-option]').forEach(function(opt) {
      const val      = opt.dataset.destinationOption;
      const isActive = val === selected;
      const isLink   = opt.dataset.destinationStyle === 'link';

      if (isLink) {
        // Link-style option: toggle opacity + weight, no border
        opt.style.opacity    = isActive ? '1' : '0.6';
        opt.style.fontWeight = isActive ? '700' : '';
        opt.style.textDecorationStyle = isActive ? 'solid' : 'dashed';
      } else {
        // Card-style option: highlighted border + subtle background when selected
        if (isActive) {
          opt.style.borderColor = 'currentColor';
          opt.style.boxShadow   = '0 0 0 1px currentColor';
          opt.style.background  = 'rgba(0,0,0,0.04)';
        } else {
          opt.style.borderColor = 'rgba(0,0,0,0.18)';
          opt.style.boxShadow   = '';
          opt.style.background  = '';
        }
      }

      const dot = opt.querySelector('.counter-checkout__destination-radio-dot');
      if (dot) dot.style.opacity = isActive ? '1' : '0';

      // Extra inside the label (legacy support)
      const extraInside = opt.querySelector('.counter-checkout__destination-extra');
      if (extraInside) {
        if (isActive) extraInside.classList.remove('hidden');
        else          extraInside.classList.add('hidden');
      }

      // Standalone extra matched by data-destination-extra attribute
      const extraOutside = document.querySelector('[data-destination-extra="' + val + '"]');
      if (extraOutside) {
        if (isActive) extraOutside.classList.remove('hidden');
        else          extraOutside.classList.add('hidden');
      }
    });
  }

  /**
   * Show counter checkout modal
   */
  function showCounterCheckoutModal() {
    const cartMainContent = document.getElementById('cart-main-content');
    const counterCheckoutModal = document.getElementById('counter-checkout-modal');
    console.log('Showing counter checkout modal');
    if (cartMainContent && counterCheckoutModal) {
      cartMainContent.style.display = 'none';
      counterCheckoutModal.classList.remove('hidden');
      initDestinationSelector();
    }
  }

  /**
   * Populate the "other store" select and refresh visual state.
   * No event listeners here — clicks are handled via document-level delegation
   * so they work regardless of how the modal was opened.
   */
  function initDestinationSelector() {
    const selectEl = document.getElementById('dest-other-select');
    if (selectEl) {
      selectEl.innerHTML = '<option value="">Selecciona una tienda</option>';
      const retailLocation = localStorage.getItem('retail-location') || '';
      if (window.RETAILS?.locations?.length) {
        window.RETAILS.locations.forEach(function(loc) {
          if (loc.metafields?.acronym === retailLocation) return;
          const opt = document.createElement('option');
          opt.value = loc.id;
          opt.textContent = loc.name;
          selectEl.appendChild(opt);
        });
      }
    }
    // Reflect current radio state (e.g. after form.reset())
    updateDestinationUI();
  }

  // Spanish postal code prefix (first 2 digits) → province name
  // Used for instant province auto-selection without any API call
  const PROVINCE_BY_ZIP_PREFIX = {
    '01': 'Álava',        '02': 'Albacete',    '03': 'Alicante',
    '04': 'Almería',      '05': 'Ávila',        '06': 'Badajoz',
    '07': 'Illes Balears', '08': 'Barcelona',    '09': 'Burgos',
    '10': 'Cáceres',      '11': 'Cádiz',        '12': 'Castellón',
    '13': 'Ciudad Real',   '14': 'Córdoba',      '15': 'A Coruña',
    '16': 'Cuenca',        '17': 'Girona',       '18': 'Granada',
    '19': 'Guadalajara',   '20': 'Gipuzkoa',     '21': 'Huelva',
    '22': 'Huesca',        '23': 'Jaén',          '24': 'León',
    '25': 'Lleida',        '26': 'La Rioja',     '27': 'Lugo',
    '28': 'Madrid',        '29': 'Málaga',       '30': 'Murcia',
    '31': 'Navarra',       '32': 'Ourense',      '33': 'Asturias',
    '34': 'Palencia',      '35': 'Las Palmas',   '36': 'Pontevedra',
    '37': 'Salamanca',     '38': 'Santa Cruz de Tenerife', '39': 'Cantabria',
    '40': 'Segovia',       '41': 'Sevilla',      '42': 'Soria',
    '43': 'Tarragona',     '44': 'Teruel',       '45': 'Toledo',
    '46': 'Valencia',      '47': 'Valladolid',   '48': 'Bizkaia',
    '49': 'Zamora',        '50': 'Zaragoza',     '51': 'Ceuta',
    '52': 'Melilla'
  };

  let zipLookupTimer = null;

  // ── Virtual Keyboard state ────────────────────────────────────────────────
  var vkKeyboard    = null;  // simple-keyboard instance
  var vkActiveInput = null;  // the <input> currently being typed into
  // ─────────────────────────────────────────────────────────────────────────

  /**
   * Given a 5-digit Spanish postal code:
   *  1. Instantly selects the province from the prefix map (no API, 100% reliable)
   *  2. Asynchronously fetches the city name from zippopotam.us
   *     and fills it in if the field is still empty (user can always override)
   */
  async function lookupPostalCode(zip, countryCode) {
    countryCode = countryCode || 'es';

    // 1. Province — instant, only available for Spain via prefix map
    if (countryCode === 'es') {
      const prefix = zip.substring(0, 2);
      const province = PROVINCE_BY_ZIP_PREFIX[prefix] || '';
      const provinceSelect = document.getElementById('dest-address-province');
      if (provinceSelect && province) {
        provinceSelect.value = province;
      }
    }

    // 2. City — async via zippopotam.us (supports es / pt / it)
    const loadingEl = document.getElementById('dest-address-zip-loading');
    const cityInput  = document.getElementById('dest-address-city');
    if (!cityInput) return;

    if (loadingEl) loadingEl.classList.remove('hidden');
    try {
      const res = await fetch('https://api.zippopotam.us/' + countryCode + '/' + zip);
      if (res.ok) {
        const data = await res.json();
        const city = data.places?.[0]?.['place name'] || '';
        if (city) {
          cityInput.value = city;
          cityInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
    } catch (_) {
      // Silent fail — city field stays editable for manual input
    } finally {
      if (loadingEl) loadingEl.classList.add('hidden');
    }
  }

  // ── Virtual Keyboard functions ────────────────────────────────────────────

  /**
   * Dynamically loads simple-keyboard CSS + JS from jsDelivr CDN.
   * Calls callback() once both are ready. Safe to call multiple times.
   */
  function loadSimpleKeyboard(callback) {
    if (typeof window.SimpleKeyboard !== 'undefined') { callback(); return; }
    var link  = document.createElement('link');
    link.rel  = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/simple-keyboard@3.7.17/build/css/index.css';
    document.head.appendChild(link);
    var script     = document.createElement('script');
    script.src     = 'https://cdn.jsdelivr.net/npm/simple-keyboard@3.7.17/build/index.js';
    script.onload  = callback;
    script.onerror = function() { console.warn('[VK] simple-keyboard failed to load from CDN'); };
    document.head.appendChild(script);
  }

  /** Hide the virtual keyboard and reset scroll state. */
  function hideKeyboard() {
    var wrap = document.getElementById('counter-checkout-keyboard-wrap');
    if (wrap) wrap.classList.add('hidden');
    var flow = document.getElementById('counter-checkout-content-flow');
    if (flow) flow.style.overflowY = '';
    vkActiveInput = null;
  }

  /**
   * Show the virtual keyboard anchored to a given input element.
   * Picks the right layout (numeric / email / default) automatically.
   */
  function showKeyboard(inputEl) {
    vkActiveInput = inputEl; // Track even if keyboard isn't ready yet
    if (!vkKeyboard) return; // Will be shown once the CDN finishes loading
    var wrap = document.getElementById('counter-checkout-keyboard-wrap');
    if (!wrap) return; 

    vkActiveInput = inputEl;

    // Sync keyboard internal state with the field's current value
    vkKeyboard.setInput(inputEl.value || '');

    // Pick layout based on which field just got focus
    var id        = inputEl.id || '';
    var isEmail   = (id === 'counter-checkout-email');
    var isNumeric = (id === 'dest-address-zip') || (inputEl.inputMode === 'numeric');
    var layout    = isNumeric ? 'numeric' : (isEmail ? 'email' : 'default');
    vkKeyboard.setOptions({ layoutName: layout });

    wrap.classList.remove('hidden');

    // Make the content area scrollable so the active field stays visible above the keyboard
    var flow = document.getElementById('counter-checkout-content-flow');
    if (flow) {
      flow.style.overflowY = 'auto';
      setTimeout(function() { inputEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 80);
    }
  }

  /**
   * Create the simple-keyboard instance and attach it to #counter-checkout-keyboard.
   * Only runs in vertical mode. The CDN load is async so this is called early in init().
   */
  function initVirtualKeyboard() {
    if (!isVerticalMode()) return;
    loadSimpleKeyboard(function() {
      var container = document.getElementById('counter-checkout-keyboard');
      if (!container) return;
      if (vkKeyboard) return; // already initialized
      var KeyboardClass = (window.SimpleKeyboard && window.SimpleKeyboard.default) || window.SimpleKeyboard;
      if (!KeyboardClass) { console.warn('[VK] SimpleKeyboard class not found'); return; }

      // Pass the class selector (with leading dot) — simple-keyboard requires
      // the element to have a class and uses it as its internal keyboardDOMClass.
      // Passing a raw DOM element without a class throws KEYBOARD_DOM_CLASS_ERROR.
      vkKeyboard = new KeyboardClass('.counter-checkout-kb-container', {
        onChange: function(input) {
          if (!vkActiveInput) return;
          vkActiveInput.value = input;
          // Fire native input event so existing handlers (zip formatter, etc.) still run
          vkActiveInput.dispatchEvent(new Event('input', { bubbles: true }));
          // Re-sync if a handler (e.g. zip auto-hyphen) changed the value
          if (vkActiveInput.value !== input) {
            vkKeyboard.setInput(vkActiveInput.value);
          }
        },
        onKeyPress: function(button) {
          // Toggle shift (only relevant for default/shift layouts)
          if (button === '{shift}') {
            var cur = vkKeyboard.options.layoutName;
            if (cur === 'default')      vkKeyboard.setOptions({ layoutName: 'shift' });
            else if (cur === 'shift')   vkKeyboard.setOptions({ layoutName: 'default' });
          }
          // Close button hides keyboard
          if (button === '{close}') {
            hideKeyboard();
            if (vkActiveInput) vkActiveInput.blur();
          }
        },
        layout: {
          default: [
            '1 2 3 4 5 6 7 8 9 0 {bksp}',
            'q w e r t y u i o p',
            'a s d f g h j k l ñ',
            '{shift} z x c v b n m {shift}',
            '{space} . , - \' {close}'
          ],
          shift: [
            '! " # $ % & / ( ) = {bksp}',
            'Q W E R T Y U I O P',
            'A S D F G H J K L Ñ',
            '{shift} Z X C V B N M {shift}',
            '{space} . , - \' {close}'
          ],
          email: [
            '1 2 3 4 5 6 7 8 9 0 {bksp}',
            'q w e r t y u i o p',
            'a s d f g h j k l _',
            '@ . - {space} {bksp}',
            '.com .es .net {close}'
          ],
          numeric: [
            '7 8 9',
            '4 5 6',
            '1 2 3',
            '- 0 {bksp}',
            '{close}'
          ]
        },
        display: {
          '{bksp}':  '⌫',
          '{shift}': '⇧',
          '{space}': 'Espacio',
          '{close}': '✕ cerrar'
        },
        mergeDisplay: true,
        theme: 'hg-theme-default hg-layout-default counter-checkout-kb'
      });

      console.log('[VK] Virtual keyboard initialized');

      // If a field was focused while the CDN was still loading, show the keyboard now
      if (vkActiveInput) {
        showKeyboard(vkActiveInput);
      }
    });
  }

  // ── End Virtual Keyboard ──────────────────────────────────────────────────

  /**
   * Build payload for Comerzzia API
   * @param {object} cartData
   * @param {string} email
   * @param {string} customerName
   * @param {boolean} acceptsMarketing
   * @param {object} deliveryData  - { type: 'current'|'other'|'address', location?: object, address?: object }
   */
  function buildPayload(cartData, email, customerName, acceptsMarketing, deliveryData) { 
    // Get retail location from localStorage if available
    const retailLocation = localStorage.getItem('retail-location') || 'Sin especificar';

    // Resolve location and shippingAddress based on delivery type
    let resolvedLocation = null;
    let shippingAddress = null;
    let tags = 'venta_pantalla,comerzzia-pos';

    const payLocation = window.RETAILS?.locations?.find(
        loc => loc.metafields?.acronym === retailLocation
      ) || null;

    if (deliveryData.type === 'current') {
      // Current store: use localStorage acronym to find location
      resolvedLocation = window.RETAILS?.locations?.find(
        loc => loc.metafields?.acronym === retailLocation
      ) || null;
      shippingAddress = resolvedLocation ? {
        name: resolvedLocation.name,
        address: resolvedLocation.address1,
        city: resolvedLocation.city,
        postal_code: resolvedLocation.zip,
        province: resolvedLocation.province,
        country: resolvedLocation.country,
        phone: resolvedLocation.phone
      } : null;
      // Tags: base + retailLocation + envio_tienda + country + codalm_XXX
      const codalm = resolvedLocation?.metafields?.warehouse_code || null;
      const country = resolvedLocation?.country || '';
      tags += `,${retailLocation},envio_tienda,${country}`;
      if (codalm) tags += `,codalm_${codalm},payalm_${payLocation?.metafields?.warehouse_code || 'N/A'}`;

    } else if (deliveryData.type === 'other') {
      // Other store: location comes from the select
      resolvedLocation = deliveryData.location || null;
      shippingAddress = resolvedLocation ? {
        name: resolvedLocation.name,
        address: resolvedLocation.address1,
        city: resolvedLocation.city,
        postal_code: resolvedLocation.zip,
        province: resolvedLocation.province,
        country: resolvedLocation.country,
        phone: resolvedLocation.phone
      } : null;
      // Tags: base + retailLocation + envio_tienda + country + codalm_XXX
      const codalm = resolvedLocation?.metafields?.warehouse_code || null;
      const country = resolvedLocation?.country || '';
      tags += `,${retailLocation},envio_tienda,${country}`;
      if (codalm) tags += `,codalm_${codalm},payalm_${payLocation?.metafields?.warehouse_code || 'N/A'}`;

    } else if (deliveryData.type === 'address') {
      // Home delivery: shippingAddress from form fields, no store-specific tags
      resolvedLocation = window.RETAILS?.locations?.find(
        loc => loc.metafields?.acronym === retailLocation
      ) || null;
      shippingAddress = deliveryData.address || null;
      tags += `,${retailLocation},envio_custom,payalm_${payLocation?.metafields?.warehouse_code || 'N/A'}`;
    }

    console.log('buildPayload deliveryData:', deliveryData, '| resolvedLocation:', resolvedLocation, '| tags:', tags);

    // Shipping cost calculation (only for home delivery)
    const shippingCost = deliveryData.type === 'address'
      ? (window.SHOP_CONFIG?.shippingCosts?.[deliveryData.address?.countryCode || 'es'] || 0)
      : 0;

    const shippingLines = shippingCost > 0 ? [{
      title: 'Envío a domicilio',
      price: shippingCost,
      code: 'HOME_DELIVERY'
    }] : [];

    console.log('buildPayload shippingCost:', shippingCost, '| shippingLines:', shippingLines);

    return {
      email: email,
      customer_name: customerName,
      accepts_marketing: acceptsMarketing,
      tags: tags,
      shopifyname: 'tramasmas',
      location_id: resolvedLocation ? resolvedLocation.id : 'N/A',
      codalm: payLocation?.metafields?.warehouse_code || 'N/A',
      sendalm: deliveryData.type === 'address' ? '' : resolvedLocation?.metafields?.warehouse_code || 'N/A',
      shipping_cost: shippingCost,
      shipping_address: shippingAddress,
      cart: {
        token: cartData.token,
        note: cartData.note,
        attributes: cartData.attributes,
        original_total_price: cartData.original_total_price,
        total_price: cartData.total_price + shippingCost,
        total_discount: cartData.total_discount,
        total_weight: cartData.total_weight,
        item_count: cartData.item_count,
        items: cartData.items.map(item => ({
          id: item.id,
          product_id: item.product_id,
          variant_id: item.variant_id,
          title: item.title,
          product_title: item.product_title,
          variant_title: item.variant_title,
          sku: item.sku,
          vendor: item.vendor,
          quantity: item.quantity,
          price: item.price,
          final_price: item.final_price,
          line_price: item.line_price,
          final_line_price: item.final_line_price,
          discounts: item.discounts,
          properties: item.properties
        })),
        cart_level_discount_applications: cartData.cart_level_discount_applications,
        shipping_lines: shippingLines
      },
      metadata: {
        mode: 'vertical',
        retail_location: retailLocation,
        timestamp: new Date().toISOString(),
        currency: cartData.currency
      }
    };
  }


  /**
   * Clear cart after successful checkout
   */
  async function clearCart() {
    try {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) throw new Error('Failed to clear cart');
      
      // Trigger cart update event
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    } catch (error) {
      console.error('Error clearing cart:', error);
    }
  }

  

  /**
   * Send cart data to Comerzzia endpoint
   */
  async function sendToComerzzia(payload) {
    try {
      const response = await fetch(CONFIG.ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      console.log('Comerzzia response status:', response );
      const text = await response.text();
      console.log("Raw response:", text);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return response;
    } catch (error) {
      console.error('Error sending to Comerzzia:', error);
      throw error;
    }
  }

  /**
   * Handle form submission
   */
  async function handleFormSubmit(event) {
    event.preventDefault();

    if (cartHasRestrictedLowStockItems()) {
      showStatus(window.SHOP_CONFIG?.i18n?.error_low_stock || 'No se permite el pago en caja si algún artículo tiene menos de 10 unidades disponibles.', true);
      return;
    }
    
    // DOM Elements
    const counterCheckoutButton = document.querySelector('[data-counter-checkout-button]');
    const counterCheckoutModal = document.getElementById('counter-checkout-modal');
    const counterBackButton = document.querySelector('[data-counter-back-button]');
    const counterCheckoutForm = document.getElementById('counter-checkout-form');

    console.log('Counter checkout elements:', {
      button: !!counterCheckoutButton,
      modal: !!counterCheckoutModal,
      form: !!counterCheckoutForm
    });

    if (!counterCheckoutButton || !counterCheckoutModal || !counterCheckoutForm) {
      console.warn('Counter checkout elements not found');
      return;
    }

    const emailInput = document.getElementById('counter-checkout-email');
    const nameInput = document.getElementById('counter-checkout-name');
    const marketingInput = document.getElementById('counter-checkout-marketing');
    const email = emailInput?.value.trim();
    const customerName = nameInput?.value.trim() || 'Cliente sin nombre';
    const acceptsMarketing = marketingInput?.checked === true;

    // --- Read delivery destination ---
    const destinationType = document.querySelector('input[name="destination_type"]:checked')?.value || 'current';
    let deliveryData = { type: destinationType };

    if (destinationType === 'other') {
      const selectEl = document.getElementById('dest-other-select');
      const selectedValue = selectEl?.value;
      if (!selectedValue) {
        showStatus(window.SHOP_CONFIG?.i18n?.error_select_store || 'Por favor, selecciona una tienda de destino', true);
        return;
      }
      const selectedLocation = window.RETAILS?.locations?.find(
        loc => String(loc.id) === String(selectedValue)
      ) || null;
      deliveryData.location = selectedLocation;

    } else if (destinationType === 'address') {
      const addrName     = document.getElementById('dest-address-name')?.value.trim();
      const addrStreet   = document.getElementById('dest-address-street')?.value.trim();
      const addrZip      = document.getElementById('dest-address-zip')?.value.trim();
      const addrCity     = document.getElementById('dest-address-city')?.value.trim();
      const addrCountry  = document.getElementById('dest-address-country')?.value || 'España';
      // Provincia: select si España, input de texto si otro país
      const isSpain      = addrCountry === 'España';
      const addrProvince = isSpain
        ? document.getElementById('dest-address-province')?.value.trim()
        : document.getElementById('dest-address-province-text')?.value.trim();
      // Country code from data attribute (es, pt, it)
      const countrySelect = document.getElementById('dest-address-country');
      const selectedCountryOpt = countrySelect?.options[countrySelect.selectedIndex];
      const addrCountryCode = selectedCountryOpt?.dataset.zipCode || 'es';
      if (!addrStreet || !addrZip || !addrCity) {
        showStatus(window.SHOP_CONFIG?.i18n?.error_fill_address || 'Por favor, completa los campos obligatorios (dirección, código postal y ciudad)', true);
        return;
      }
      deliveryData.address = {
        name: addrName || customerName,
        address: addrStreet,
        city: addrCity,
        postal_code: addrZip,
        province: addrProvince || '',
        country: addrCountry,
        countryCode: addrCountryCode,
        phone: ''
      };
    }
    // ---------------------------------

    if (!customerName) {
      showStatus(window.SHOP_CONFIG?.i18n?.error_fill_name || 'Por favor, introduce tu nombre', true);
      return;
    }

    const emailRegex = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
    if (!email || !emailRegex.test(email)) {
      showStatus(window.SHOP_CONFIG?.i18n?.error_fill_email || 'Por favor, introduce un email válido', true);
      return;
    }

    // Disable form while processing
    const submitButton = counterCheckoutForm.querySelector('button[type="submit"]');
    const originalButtonText = submitButton?.querySelector('.btn-text')?.textContent;
    
    if (submitButton) {
      submitButton.disabled = true;
      const btnText = submitButton.querySelector('.btn-text');
      if (btnText) btnText.textContent = window.SHOP_CONFIG?.i18n?.processing || 'Procesando...';
    }

    showStatus(window.SHOP_CONFIG?.i18n?.loading_cart || 'Obteniendo datos del carrito...');


    try {
      // Get cart data
      const cartData = await getCartData();

      if (!cartData.items || cartData.items.length === 0) {
        showStatus(window.SHOP_CONFIG?.i18n?.empty_cart || 'El carrito está vacío', true);
        return;
      }

      // Build payload
      const payload = buildPayload(cartData, email, customerName, acceptsMarketing, deliveryData);

      let isSimulacro = CONFIG.ENDPOINT.includes('example');

      if (isSimulacro) {
        console.log('=================================');
        console.log('PAYLOAD GENERADO PARA COMERZZIA***:');
        console.log('=================================');
        console.log(JSON.stringify(payload, null, 2));
        console.log('=================================');
      } else {
        showStatus(window.SHOP_CONFIG?.i18n?.sending || 'Enviando pedido a caja...');
        // Enviar petición real
        const responseCommerzia = await sendToComerzzia(payload);
        console.log('Respuesta de Comerzzia:', responseCommerzia);
      }

      // Mostrar mensaje y bloquear modal en ambos casos
      showStatus(window.SHOP_CONFIG?.i18n?.success || 'Por favor dirígete a caja para completar el pago.', false);
      if (counterBackButton) counterBackButton.disabled = true;
      if (counterCheckoutModal) counterCheckoutModal.dataset.locked = 'true';

      // Re-enable form (opcional)
      if (submitButton) {
        submitButton.disabled = false;
        const btnText = submitButton.querySelector('.btn-text');
        if (btnText && originalButtonText) {
          btnText.textContent = originalButtonText;
        }
      }
      document.addEventListener('keydown', preventModalClose, true);
      counterCheckoutModal?.addEventListener('click', preventModalClose, true);

      // Esperar 5 segundos, luego limpiar carrito y volver a home/cerrar modal
      setTimeout(() => {
        if (counterBackButton) counterBackButton.disabled = false;
        if (counterCheckoutModal) delete counterCheckoutModal.dataset.locked;
        document.removeEventListener('keydown', preventModalClose, true);
        counterCheckoutModal?.removeEventListener('click', preventModalClose, true);
        
        //cerrar el drawer y limpiar carrito
        const cartDrawer = document.querySelector('[aria-controls="CartDrawer"]');
        if (cartDrawer) {
          cartDrawer.click();
        }
        clearCart().then(() => {
          if (isSimulacro) {
            window.location.href = '/';
          } else {
            hideCounterCheckoutModal(); 
            window.location.href = '/'; 
          }
        });
      }, 5000);
      return;

    } catch (error) {
      console.error('Counter checkout error:', error);

      // For development: show detailed error
      if (CONFIG.ENDPOINT.includes('example')) {
        showStatus('Modo de prueba: El endpoint de Comerzzia aún no está configurado. Payload generado correctamente (ver consola).', false);
        console.log('Generated payload:', await getCartData().then(data => buildPayload(data, email)));
      } else {
        showStatus(window.SHOP_CONFIG?.i18n?.error_generic || 'Error al procesar el pedido. Por favor, inténtalo de nuevo.', true);
      }
    } finally {
      // Re-enable form
      if (submitButton) {
        submitButton.disabled = false;
        const btnText = submitButton.querySelector('.btn-text');
        if (btnText && originalButtonText) {
          btnText.textContent = originalButtonText;
        }
      }
    }
  }

  // Wait for DOM to be ready
  function init() {
    console.log('Counter checkout init called');
    
    // Only initialize if in vertical mode
    if (!isVerticalMode()) {
      console.log('Not in vertical mode, skipping counter checkout');
      return;
    }

    console.log('Vertical mode detected, initializing counter checkout');

    // Start loading the virtual keyboard early so it's ready when the modal opens
    initVirtualKeyboard();

    // DOM Elements
    const counterCheckoutButton = document.querySelector('[data-counter-checkout-button]');
    const counterCheckoutModal = document.getElementById('counter-checkout-modal');
    const counterBackButton = document.querySelector('[data-counter-back-button]');
    const counterCheckoutForm = document.getElementById('counter-checkout-form');
    const cartMainContent = document.getElementById('cart-main-content');

    console.log('Counter checkout elements:', {
      button: !!counterCheckoutButton,
      modal: !!counterCheckoutModal,
      form: !!counterCheckoutForm
    });

    if (!counterCheckoutButton || !counterCheckoutModal || !counterCheckoutForm) {
      console.warn('Counter checkout elements not found');
      return; 
    }

    // Event Listeners
    counterCheckoutButton.addEventListener('click', function(e) {
      console.log('Counter checkout button clicked');
      showCounterCheckoutModal();
    });
    counterBackButton?.addEventListener('click', hideCounterCheckoutModal);
    // El listener de submit se gestiona por delegación a nivel de document para mayor robustez

    console.log('Counter checkout initialized successfully');
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also try to reinitialize when cart drawer opens or when elements appear
  //setTimeout(init, 1000);
  //setTimeout(init, 2000);
  
  // Use event delegation on the document level to catch clicks
  document.addEventListener('click', function(e) {
    const target = e.target.closest('[data-counter-checkout-button]');
    if (target) {
      console.log('Button clicked via event delegation!');
      e.preventDefault();

      if (cartHasRestrictedLowStockItems()) {
        window.alert('No se permite el pago en caja si algún artículo tiene menos de 10 unidades disponibles.');
        return;
      }
      
      if (!isVerticalMode()) {
        console.log('Not in vertical mode');
        return;
      }
      
      const modal = document.getElementById('counter-checkout-modal');
      const cartContent = document.getElementById('cart-main-content');
      
      if (modal && cartContent) {
        console.log('Opening modal...');
        cartContent.style.display = 'none';
        modal.classList.remove('hidden');
        initDestinationSelector();
      } else {
        console.log('Modal or cart content not found:', {modal: !!modal, cartContent: !!cartContent});
      }
    }
    
    // Handle destination option card clicks
    const destOption = e.target.closest('[data-destination-option]');
    if (destOption && destOption.closest('#counter-checkout-modal')) {
      // e.preventDefault() stops the browser from firing a second synthetic
      // click on the nested radio, ensuring updateDestinationUI runs exactly once
      // with the already-updated radio state.
      e.preventDefault();
      const val   = destOption.dataset.destinationOption;
      const radio = document.getElementById('dest-' + val);
      if (radio) {
        radio.checked = true;
        updateDestinationUI();
      }
      return;
    }

    // Handle back button
    const backButton = e.target.closest('[data-counter-back-button]');
    if (backButton) {
      e.preventDefault();
      const modal = document.getElementById('counter-checkout-modal');
      const cartContent = document.getElementById('cart-main-content');
      const form = document.getElementById('counter-checkout-form');
      
      if (modal && cartContent) {
        modal.classList.add('hidden');
        cartContent.style.display = 'flex';
        if (form) form.reset();
        hideKeyboard();
      }
    }
  });
  
  // Use event delegation for form submission

  // Event delegation para submit del formulario counter-checkout-form
  document.addEventListener('submit', function(e) {
    if (e.target && e.target.id === 'counter-checkout-form') {
      e.preventDefault();
      hideKeyboard();
      handleFormSubmit(e);
    }
  });

  // Country selector: toggles ZIP constraints and province field type
  document.addEventListener('change', function(e) {
    if (e.target && e.target.id === 'dest-address-country') {
      const selectedOpt  = e.target.options[e.target.selectedIndex];
      const countryCode  = selectedOpt?.dataset.zipCode || 'es';
      const zipDigits    = parseInt(selectedOpt?.dataset.zipDigits || '5', 10);
      const isSpain      = countryCode === 'es';
      const isNumericZip = (countryCode === 'es' || countryCode === 'pt' || countryCode === 'it');

      const zipInput             = document.getElementById('dest-address-zip');
      const provinceSelectWrap   = document.getElementById('dest-address-province-select-wrap');
      const provinceTextWrap     = document.getElementById('dest-address-province-text-wrap');
      const provinceSelect       = document.getElementById('dest-address-province');
      const provinceText         = document.getElementById('dest-address-province-text');
      const cityInput            = document.getElementById('dest-address-city');

      // Update ZIP field constraints
      if (zipInput) {
        zipInput.value = '';
        if (countryCode === 'pt') {
          zipInput.maxLength  = 8;    // XXXX-XXX
          zipInput.inputMode  = 'numeric'; // numeric keyboard, hyphen inserted automatically
        } else if (countryCode === 'es' || countryCode === 'it') {
          zipInput.maxLength  = 5;
          zipInput.inputMode  = 'numeric';
        } else {
          zipInput.maxLength  = 10;
          zipInput.inputMode  = 'text';
        }
      }

      // Toggle province field
      if (isSpain) {
        if (provinceSelectWrap) provinceSelectWrap.classList.remove('hidden');
        if (provinceTextWrap)   provinceTextWrap.classList.add('hidden');
      } else {
        if (provinceSelectWrap) provinceSelectWrap.classList.add('hidden');
        if (provinceTextWrap)   provinceTextWrap.classList.remove('hidden');
      }

      // Clear dependent fields
      if (cityInput)     cityInput.value    = '';
      if (provinceSelect) provinceSelect.value = '';
      if (provinceText)  provinceText.value = '';
    }
  });

  // Handle toggle visibility buttons for password fields
  document.addEventListener('click', function(e) {
    const toggleButton = e.target.closest('[data-toggle-input]');
    if (toggleButton) {
      e.preventDefault();
      const inputId = toggleButton.getAttribute('data-toggle-input');
      const input = document.getElementById(inputId);
      
      if (input) {
        const iconOpen = toggleButton.querySelector('.icon-eye-open');
        const iconClosed = toggleButton.querySelector('.icon-eye-closed');
        
        if (input.type === 'password') {
          input.type = 'text';
          if (iconOpen) iconOpen.classList.add('hidden');
          if (iconClosed) iconClosed.classList.remove('hidden');
        } else {
          input.type = 'password';
          if (iconOpen) iconOpen.classList.remove('hidden');
          if (iconClosed) iconClosed.classList.add('hidden');
        }
      }
    }
  });

  // Postal code auto-lookup for the home-delivery address form.
  document.addEventListener('input', function(e) {
    if (e.target && e.target.id === 'dest-address-zip') {
      const countrySelect = document.getElementById('dest-address-country');
      const selectedOpt   = countrySelect?.options[countrySelect.selectedIndex];
      const countryCode   = selectedOpt?.dataset.zipCode || 'es';

      let zip = e.target.value;
      let triggerLength;

      if (countryCode === 'pt') {
        // Portugal: XXXX-XXX (8 chars including hyphen)
        // Keep only digits (max 7), auto-insert hyphen after position 4
        const digits = zip.replace(/\D/g, '').substring(0, 7);
        zip = digits.length > 4
          ? digits.substring(0, 4) + '-' + digits.substring(4)
          : digits;
        if (e.target.value !== zip) e.target.value = zip;
        triggerLength = 8; // XXXX-XXX
      } else if (countryCode === 'es' || countryCode === 'it') {
        // Spain / Italy: 5-digit numeric
        zip = zip.replace(/\D/g, '').substring(0, 5);
        if (e.target.value !== zip) e.target.value = zip;
        triggerLength = 5;
      } else {
        triggerLength = zip.length; // other countries: lookup on any input
      }

      clearTimeout(zipLookupTimer);
      if (zip.length >= triggerLength) {
        zipLookupTimer = setTimeout(function() {
          lookupPostalCode(zip, countryCode);
        }, 300);
      }
    }
  });
  // Virtual keyboard: show when a text input inside the modal gets focus
  document.addEventListener('focusin', function(e) {
    var input = e.target;
    if (!input || !input.matches) return;
    // Only act on text-like inputs inside the counter-checkout modal
    var isTextInput = input.matches('input[type="text"], input[type="email"], input[type="password"], input:not([type])');
    var inModal     = !!input.closest('#counter-checkout-modal');
    if (isTextInput && inModal && isVerticalMode()) {
      showKeyboard(input);
    }
  });

})(); 
